import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { select, Store } from '@ngrx/store';
import clone from 'just-clone';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as fromLookups from '../../../lookups';
import { PostingType, ServiceItemLookupService } from '../../../lookups';
import { IStatusMessage, SelectItem } from '../../../shared';
import { IShowErrors } from '../../../shared/errors-sidenav';
import { Account } from '../../store/account.model';
import { AccountPostingType } from '../store';
import * as reducer from '../store/account-allocation.reducer';
import * as actions from '../store/account-posting-type.actions';
import * as selectors from '../store/account-posting-type.selectors';
@Component({
    selector: 'ef-posting-account-container',
    templateUrl: './posting-account-container.component.html',
    styleUrls: ['./posting-account-container.component.scss'],
    standalone: false
})
export class PostingAccountContainerComponent implements OnInit {
    @Input() accounts: Account[];
    @Input() selectedError: IStatusMessage;
    @Output() public ShowError = new EventEmitter<IShowErrors>();
    postingTypes$: Observable<PostingType[]>;
    postingItems$: Observable<SelectItem[]>;
    constructor(
        private store: Store<reducer.State>,
        private serviceItemService: ServiceItemLookupService
    ) {}

    ngOnInit() {
        this.store.dispatch(actions.getAccountPostingTypes());
        this.store.dispatch(new fromLookups.LoadServiceItems(true, true, true));
        this.setupObservables();
    }

    setupObservables() {
        this.postingTypes$ = this.store.pipe(
            select(selectors.selectAll),
            map(x =>
                clone(x).sort((a: PostingType, b: PostingType) =>
                    a.PostingType.localeCompare(b.PostingType)
                )
            )
        );
        this.postingItems$ = this.store.pipe(
            select(fromLookups.getOtherChargeItemsLookup),
            map(items =>
                items.map(item => ({
                    label: item.ServiceItem,
                    value: item.SIListID
                }))
            )
        );
    }
    onSavePostingType($event: AccountPostingType[]) {
        this.store.dispatch(
            actions.putAccountPostingTypes({
                AccountPostingTypes: $event
            })
        );
    }
}
